export enum NotesColumns {
    Date = 0,
    CreatedBy = 1,
    Text = 2
}